export default __webpack_public_path__ + "static/2-b2f7ba0f890a0f011d688545f9736075.webp";